import React from 'react';
import styled from 'styled-components';
import { useSiteKit } from '../SiteKitContext/SiteKitContext';

// Fragments
const SiteKitLayoutWrapper = styled.div`
  align-items: start;
  display: grid;
  grid-template-columns: ${({ theme: { sidebarOpen, isMobileOrTablet } }) =>
    /**
     * There are three possible layouts cases here:
     * 1. Desktop, sidebar visible:           | <-- Sidebar --> | <-- Content --> |
     * 2. Desktop, sidebar hidden:            | <-------------------- Content --> |
     * 3. Modile/tablet, sidebar full width:  | <------- Sidebar/Content -------> |
     *
     * On desktop, when the sidebar is visible, it takes up the first grid
     * column. This column has a minimum, ideal, and maximum widths, defined
     * using the CSS clamp function. The second grid column is used to display
     * page content.
     *
     * On desktop, when the sidebar is hidden, the sidebar column is removed,
     * and the SiteKitSidebar component is not rendered. This allows page
     * content to take up the entire grid.
     *
     * On mobile/tablet, the sidebar column is also removed. This allows page
     * content AND the SiteKitSidebar component (when opened) to take up the
     * full width of the screen.
     */
    sidebarOpen && !isMobileOrTablet ? 'clamp(200px, 20vw, 300px) 1fr' : '1fr'};
  height: 100vh;
`;

// Exports
interface SiteKitLayoutProps {
  children: React.ReactNode;
}
const SiteKitLayout = ({ children }: SiteKitLayoutProps) => {
  const { isMobileOrTablet, sidebarOpen } = useSiteKit();
  return <SiteKitLayoutWrapper theme={{ sidebarOpen, isMobileOrTablet }}>{children}</SiteKitLayoutWrapper>;
};

SiteKitLayout.displayName = 'SiteKit.Layout';

export { SiteKitLayout, SiteKitLayoutProps };
